export const sales = {
  quote: "عرض السعر",
  quotesDescription: "تتحول عروض الأسعار إلى أوامر بيع عند قبولها.",
  inquiries: "طلبات عرض الأسعار",
  salesOrders: "أوامر البيع",
  newQuote: "عرض سعر جديد",
  quotes: "عروض الأسعار",
  backToQuotes: "العودة إلى عروض الأسعار",
  notFound: "عرض السعر غير موجود.",
  declinedToast: "تم رفض عرض السعر",
  quoteTitle: "عرض السعر {number}",
  revisionNo: "المراجعة {no}",
  sentToast: "تم إرسال عرض السعر",
  send: "إرسال",
  reviseToast: "بدأت مراجعة جديدة",
  revise: "مراجعة",
  acceptToast: "تم القبول — أُنشئ أمر البيع",
  accept: "قبول",
  decline: "رفض",
  declineTitle: "هل تريد رفض عرض السعر هذا؟",
  declineConfirm: "رفض عرض السعر",
  reasonOptional: "السبب (اختياري)",
  validUntil: "صالح حتى {date}",
  leadTime: "مدة التنفيذ {days} يوم",
  rfqsTitle: "طلبات عرض الأسعار (RFQ)",
  rfqsDescription: "طلبات العملاء في انتظار عرض سعر.",
  recordInquiry: "تسجيل طلب عرض سعر",
  recordInquiryTitle: "تسجيل طلب عرض سعر",
  inquiry: "طلب عرض السعر",
  source: "المصدر",
  received: "تاريخ الاستلام",
  rfqs: "طلبات عرض الأسعار",
  saveInquiry: "حفظ طلب عرض السعر",
  whatNeeded: "ما الذي يحتاجونه؟",
  inquiryRecorded: "تم تسجيل طلب عرض السعر",
  convertHint:
    "أنشئ عرض سعر من صفحة عروض الأسعار والطلبات لتحويل طلب عرض السعر هذا إلى عرض تجاري.",
  salesOrdersDescription: "أعمال مؤكدة من عروض أسعار مقبولة.",
  order: "أمر البيع",
  ordered: "تاريخ الطلب",
  lines: "البنود",
  emptyTitle: "لا توجد أوامر بعد",
  emptyDescription: "اقبل عرض سعر لإنشاء أمر بيع.",
  createJobs: "إنشاء أوامر عمل",
  createJobsFrom: "إنشاء أوامر عمل من {order}؟",
  createJobsDescription:
    "يصبح كل بند من بنود الأمر أمر عمل إنتاجي، وتُستمد العمليات والمواد من المنتج المسعَّر.",
  targetDate: "التاريخ المستهدف",
  jobsCreated: "تم إنشاء أوامر العمل",
  jobsCreatedDesc: "{count} أمر عمل من {order}.",
  startQuote: "بدء عرض سعر",
  createQuote: "إنشاء عرض السعر",
  fromInquiry: "من طلب عرض سعر (اختياري)",
  linesHint: "تُضاف البنود والأسعار والتقديرات في عرض السعر نفسه.",
  createdToast: "تم إنشاء عرض السعر",
  quoteLines: "بنود عرض السعر",
  addLine: "إضافة بند",
  noLines: "لا توجد بنود بعد. أضف بندًا لبناء عرض السعر.",
  product: "منتج",
  estCost: "التكلفة التقديرية",
  lineType: "نوع البند",
  customLine: "بند مخصص",
  fromProduct: "من منتج",
  selectProduct: "اختر منتجًا…",
  adding: "جارٍ الإضافة…",
  saveLine: "حفظ البند",
  lineAdded: "تمت إضافة البند",
  lineUpdated: "تم تحديث البند",
  lineRemoved: "تمت إزالة البند",
};
